import React, { FC } from "react";

import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { faLink } from "@fortawesome/pro-solid-svg-icons/faLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "antd/es/typography";
import cn from "classnames";
import { useIntl } from "react-intl";

import styles from "./CopyLink.module.scss";

interface Props {
  className?: string;
  link: string;
}

const CopyLink: FC<Props> = ({ className, link }) => {
  const intl = useIntl();
  return (
    <Typography.Paragraph
      className={cn(styles.container, className)}
      copyable={{
        icon: [
          <FontAwesomeIcon
            className={cn(styles.icon, styles.iconLink)}
            icon={faLink}
            key="copy-icon"
          />,
          <FontAwesomeIcon
            className={cn(styles.icon, styles.iconChecked)}
            icon={faCheckCircle}
            key="copied-icon"
          />,
        ],
        text: link,
        tooltips: [
          intl.formatMessage({
            id: "copyLink.beforeTooltip",
            defaultMessage: "Copy link to record",
            description: "Copy link tooltip before",
          }),
          intl.formatMessage({
            id: "copyLink.afterTooltip",
            defaultMessage: "Copied to clipboard!",
            description: "Copy link tooltip after",
          }),
        ],
      }}
    />
  );
};
export default CopyLink;
